const symbol = Symbol("PathProxy");

type PathProxy<T> = MappedProxy<T> & ProxyContent<T>;

type MappedProxy<T> = {
  [P in keyof T]: PathProxy<T[P]>;
};

type ProxyContent<T> = {
  _path: PropertyKey[];
  _val: T;
};

function unProxy<T>(proxy: PathProxy<T>): ProxyContent<T> {
  return (proxy as any)[symbol] as ProxyContent<T>;
}

function getPathProxy<T>(obj: T): T {
  const handler = {
    get<TGet, K extends keyof TGet>(target: PathProxy<TGet>, propKey: K /*receiver*/): TGet[K] {
      if (propKey === symbol) return target as any;
      // console.log("get: " + propKey, target._path);
      const childProxy: ProxyContent<TGet[K]> = {
        _path: [...(target._path ? target._path : []), propKey],
        _val: target && target._val ? target._val[propKey] : (undefined as any),
      };
      return new Proxy(childProxy as any, handler);
    },
  };
  const pc: ProxyContent<T> = {
    _path: [],
    _val: obj,
  };
  return new Proxy(pc as any, handler);
}

export function getPathFromSelector<F, T>(selector: (old: F) => T): PropertyKey[] {
  const proxy = getPathProxy({});
  const result = selector(proxy as any) as any as PathProxy<any>;
  const path = unProxy(result)._path;
  return path;
}

export function logPathFromSelector<F, T>(text: string, selector: (old: F) => T): void {
  try {
    console.log(text, getPathFromSelector(selector));
  } catch (e) {
    console.error(e, text);
  }
}

export function getValueFromPath<T>(object: T, path: PropertyKey[]): any {
  let current = object as any;
  for (const p of path) {
    current = current[p];
  }
  return current;
}

export function setValueFromPath<T>(object: T, path: PropertyKey[], value: any): void {
  const rest = path.slice(0, path.length - 1);
  const setPath = path[path.length - 1];
  let current = object as any;
  for (const p of rest) {
    current = current[p];
  }
  current[setPath] = value;
}
